export default __webpack_public_path__ + "static/media/avatar.363b7553.svg";